// extracted by mini-css-extract-plugin
export default {"container":"jhhUvv","lg":"Zi4gub","accessibilityTheme":"QVh3yr","stars":"Z82zP3","heading":"DgzZ1I","carousel":"cynAJa"};